var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"139","height":"51","viewBox":"0 0 139 51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }